<template>
  <div>
    <Breadcrumbs
      :current-folder="currentFolderTitle"
      :current-folder-uuid="currentFolderUuid"
      :shared-item-mode="true"
      :ancestors="ancestors"
    />
    <div
      v-if="folderHasContents && !loading"
      class="table-responsive"
    >
      <table class="table table-files min-w-table">
        <thead>
          <tr>
            <th
              colspan="7"
              class="table-caption"
            >
              <FolderActions
                v-can="'edit-documents'"
                :folder="folder"
              />
              <h2 v-html="folder.attributes.title" />
            </th>
          </tr>
          <tr>
            <!--<th></th>-->
            <!--<th></th>-->
            <th v-text="'Name'" />
            <th v-text="'Modified'" />
            <th
              v-can="'edit-documents'"
              v-text="'Member Visibility'"
            />
            <th />
            <th v-can="'edit-documents'" />
          </tr>
        </thead>
        <tbody>
          <tr
            is="FolderRow"
            v-for="childFolder in childFolders"
            :key="childFolder.uuid"
            :folder="childFolder"
            :show-actions="true"
          />
          <tr
            is="DocumentRow"
            v-for="document in documents"
            :key="document.uuid"
            :show-actions="true"
            :document="document"
          />
        </tbody>
      </table>
    </div>
    <div
      v-if="!folderHasContents && !loading"
      class="text-center py-12 flex justify-center items-center my-4 border border-grey-darker rounded shadow"
    >
      <div class="">
        <h1
          class="mb-8"
          v-text="'This folder is empty'"
        />
        <div class="mt-12">
          <FolderActions
            v-can="'edit-documents'"
            :folder="folder"
          />
        </div>
      </div>
    </div>
    <SendToMembershipGroupsModal
      :shared-item-mode="true"
      @resourceHasBeenSentToMembershipGroups="fetch"
    />
    <SendToMembershipsModal
      :shared-item-mode="true"
      @resourceHasBeenSentToMemberships="fetch"
    />
  </div>
</template>

<script type="text/babel">
import FolderRow from './SharedFolderRow'
import DocumentRow from './SharedDocumentRow'
import FolderActions from './SharedFolderActions'
import Breadcrumbs from './FolderBreadcrumbs'
import SendToMembershipGroupsModal from './_modals/SendToMembershipGroupsModal'
import SendToMembershipsModal from './_modals/SendToMembershipsModal'

export default {
  name: 'SharedFolderDetails',
  components: {
    FolderRow,
    Breadcrumbs,
    DocumentRow,
    FolderActions,
    SendToMembershipGroupsModal,
    SendToMembershipsModal,
  },
  props: {
    folderUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      folder: {
        uuid: '',
        ancestors: {
          data: [],
        },
        attributes: {
          title: '',
        },
        documents: {
          data: [],
        },
        folders: {
          uuid: '',
          attributes: {
            title: '',
          },
          data: [],
        },
      },
    }
  },
  computed: {
    currentFolderTitle() {
      return this.folder.attributes.title
    },
    currentFolderUuid() {
      return this.folder.uuid
    },
    ancestors() {
      return this.folder.ancestors.data
    },
    childFolders() {
      return this.folder.folders.data
    },
    documents() {
      return this.folder.documents.data
    },
    folderHasContents() {
      return this.folder.documents.data.length || this.folder.folders.data.length
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$api.active().get(`shares/folders/${this.folderUuid}?include=ancestors,folders,documents,parent,visibilities`)
        .then((response) => {
          this.folder = response.data
          this.loading = false
        })
    },
    openSendToMembershipGroupsModal() {
      this.$store.commit('documentOpenSendToMembershipGroupsModal', this.folder)
    },
  },
}
</script>
